$(document).on('form-ajax-success', '.js_settings-form', submitSettingSuccess)
$(document).on('click', '.js_settings-edit', editSetting)
$(document).on('click', '.js_settings-save', saveSetting)
$(document).on('click', '.js_tickets-cancel', ticketCancel)
$(document).on('change', '#profile-country-codes', profilePhoneCodeChange)
$(document).on('change', '#doc_typeSel', profileDocTypeChange)

$(document).ready(() => {
    initProfilePhoneMask()
    initProfileDocumentMask()
})

function ticketCancel() {
    let orderId = $('.js_tickets-popup .techHiddenInput').val()
    $.post('/profile/tickets', {id: orderId}, (response) => {
        if (response.result == 'success') {
            toastr.success(response.message)
            $(`.js_tickets-tr[data-id=${orderId}]`).remove()
        } else {
            toastr.error(response.message)
        }
        $('.js_tickets-close_popup').click()
    })
}

function saveSetting() {
    const $docType = $('#doc_typeSel')
    const $docNumber = $('#doc_number')

    if ($docType.length && $docNumber.length && String($docType.val()) === '0') {
        const docDigits = String($docNumber.val() || '').replace(/\D+/g, '')
        if (docDigits.length !== 10) {
            toastr.error('Номер документа имеет неверный формат (нужно 10 цифр)')
            return false
        }
    }

    $('.js_settings-form').submit()
    return false;
}

function editSetting() {
    $('.js_settings-edit').hide()
    $('.js_settings-save').show()
    let $form = $('.js_settings-form')
    $form.find('.js_settings-input').attr('disabled', false)
    initProfileDocumentMask()
    initProfileDateInput('birth_day', '01.01.2000')
    initProfileDateInput('date_social', getTodayFormatted())
    return false;
}

function submitSettingSuccess() {
    $('.js_settings-edit').show()
    $('.js_settings-save').hide()
    $('.js_settings-form').find('.js_settings-input').attr('disabled', true)
}

function initProfilePhoneMask() {
    const $countryCodes = $('#profile-country-codes')
    const $phoneInput = $('.js_settings-form .js_mask-phone')

    if (!$countryCodes.length || !$phoneInput.length) {
        return
    }

    const rawPhone = extractPhoneDigits($phoneInput.val())
    const detectedCountryCode = detectPhoneCountryCode($countryCodes, rawPhone)

    if (detectedCountryCode) {
        $countryCodes.val(detectedCountryCode)
    }

    const currentCodeKey = $countryCodes.val()
    const currentCodeDigits = getPhoneCodeDigitsByKey($countryCodes, currentCodeKey)
    const localDigits = stripPhoneCode(rawPhone, currentCodeDigits)

    switchProfilePhoneMask(currentCodeKey, $phoneInput, localDigits)
    $countryCodes.data('current-code', currentCodeKey)
}

function profilePhoneCodeChange() {
    const $countryCodes = $(this)
    const $phoneInput = $('.js_settings-form .js_mask-phone')
    if (!$phoneInput.length) {
        return
    }

    const previousCode = $countryCodes.data('current-code')
    const previousCodeDigits = getPhoneCodeDigitsByKey($countryCodes, previousCode)
    const currentPhoneDigits = extractPhoneDigits($phoneInput.val())
    const localDigits = stripPhoneCode(currentPhoneDigits, previousCodeDigits)
    const newCodeKey = $countryCodes.val()

    switchProfilePhoneMask(newCodeKey, $phoneInput, localDigits)
    $countryCodes.data('current-code', newCodeKey)
}

function switchProfilePhoneMask(countryCodeKey, $phoneInput, localDigits = '') {
    const phoneMasks = {
        us: "+1 (999) 999-99-99",
        gr: "+30 (999) 999-99-99",
        nl: "+31 (999) 999-999",
        be: "+32 (999) 999-999",
        fr: "+33 (999) 99-99-99",
        es: "+34 (999) 999-999",
        prt: "+351 (999) 999-999",
        ie: "+353 (999) 999-999",
        mt: "+356 (99) 999-999",
        fi: "+358 (999) 999-999",
        bg: "+35\\9 (999) 999-999",
        hu: "+36 (999) 999-999",
        lt: "+370 (999) 99-999",
        lv: "+371 (999) 99-9-99",
        ee: "+372 (99) 99-999",
        md: "+373 (999) 99999",
        by: "+375 (99) 999-99-99",
        ua: "+380 (99) 999-99-99",
        it: "+3\\9 (999) 999-99-99",
        ro: "+40 (999) 999-999",
        ch: "+41 (999) 999-999",
        cz: "+420 (999) 999-999",
        sk: "+421 (999) 999-999",
        au: "+43 (999) 999-99-99",
        gb: "+44 (999) 999-99-99",
        dk: "+45 (999) 99-9-99",
        se: "+46 (999) 999-999",
        no: "+47 (999) 99-9-99",
        pl: "+48 (999) 999-999",
        de: "+4\\9 (999) 999-999-99",
        ru: "+7 (999) 999-99-99",
        tr: "+\\90 (999) 999-99-99",
        ae: "+\\971 (9)9-999-99-99",
        il: "+\\972 (99) 999-99-99",
        tj: "+\\9\\92 (999) 999-999",
        tm: "+\\9\\93 (999) 999-999",
        az: "+\\9\\94 (999) 999-999",
        ge: "+\\9\\95 (999) 999-999",
        kg: "+\\9\\96 (999) 999-999",
        uz: "+\\9\\98 (999) 999-999",
    }

    if (typeof $phoneInput.inputmask !== 'function') {
        return
    }

    $phoneInput.inputmask('remove')

    if (phoneMasks[countryCodeKey]) {
        $phoneInput.inputmask(phoneMasks[countryCodeKey])
    }

    $phoneInput.val(localDigits || '')
}

function detectPhoneCountryCode($countryCodes, rawPhone) {
    if (!rawPhone) {
        return $countryCodes.val()
    }

    const codes = $countryCodes.find('option').map(function () {
        return {
            key: $(this).val(),
            code: extractPhoneDigits($(this).text())
        }
    }).get().sort((a, b) => b.code.length - a.code.length)

    for (const item of codes) {
        if (item.code && rawPhone.indexOf(item.code) === 0) {
            return item.key
        }
    }

    return $countryCodes.val()
}

function getPhoneCodeDigitsByKey($countryCodes, codeKey) {
    if (!codeKey) {
        return ''
    }

    const option = $countryCodes.find(`option[value="${codeKey}"]`)
    if (!option.length) {
        return ''
    }

    return extractPhoneDigits(option.text())
}

function stripPhoneCode(phone, code) {
    if (!phone) {
        return ''
    }

    if (code && phone.indexOf(code) === 0) {
        return phone.substring(code.length)
    }

    return phone
}

function extractPhoneDigits(value) {
    return String(value || '').replace(/\D+/g, '')
}

function initProfileDateInput(inputName, defaultViewDate) {
    let $input = $('.js_settings-form').find(`input[name="${inputName}"]`)
    if (!$input.length) return

    let currentValue = $input.val()

    if ($input.data('datepicker')) {
        $input.datepicker('destroy')
    }

    $input.datepicker({
        format: 'dd.mm.yyyy',
        clearBtn: true,
        defaultViewDate: defaultViewDate
    })

    if (currentValue) {
        $input.datepicker('update', currentValue)
    } else {
        $input.val('')
    }

    applyDateMask($input)
}

function applyDateMask($input) {
    if (!$input.length || typeof $input.inputmask !== 'function') return

    $input.inputmask('remove')
    $input.inputmask('99.99.9999', {
        placeholder: '__.__.____',
        clearIncomplete: true,
        showMaskOnHover: false,
        oncomplete: function () {
            let value = $(this).val()
            if (!isValidDateValue(value)) {
                $(this).val('')
                toastr.error('Введите дату в формате дд.мм.гггг')
            }
        }
    })
}

function initProfileDocumentMask() {
    const $docType = $('#doc_typeSel')
    const $docNumber = $('#doc_number')

    if (!$docType.length || !$docNumber.length || typeof $docNumber.inputmask !== 'function') {
        return
    }

    switchProfileDocumentMask($docType.val(), $docNumber)
}

function profileDocTypeChange() {
    const $docType = $(this)
    const $docNumber = $('#doc_number')

    switchProfileDocumentMask($docType.val(), $docNumber)
}

function switchProfileDocumentMask(docTypeValue, $docNumber) {
    if (!$docNumber.length || typeof $docNumber.inputmask !== 'function') {
        return
    }

    $docNumber.inputmask('remove')

    if (String(docTypeValue) === '0') {
        $docNumber.inputmask('9999 999999', {
            placeholder: '',
            showMaskOnHover: false,
            showMaskOnFocus: false,
            clearIncomplete: false,
            autoUnmask: true,
        })
    }
}

function isValidDateValue(value) {
    if (!value) return true
    let parts = value.split('.')
    if (parts.length !== 3) return false

    let dd = parseInt(parts[0], 10)
    let mm = parseInt(parts[1], 10)
    let yyyy = parseInt(parts[2], 10)
    if (!dd || !mm || !yyyy) return false
    if (mm < 1 || mm > 12) return false
    if (dd < 1 || dd > 31) return false

    let date = new Date(yyyy, mm - 1, dd)
    return date.getFullYear() === yyyy && date.getMonth() === (mm - 1) && date.getDate() === dd
}

function getTodayFormatted() {
    let d = new Date()
    let dd = String(d.getDate()).padStart(2, '0')
    let mm = String(d.getMonth() + 1).padStart(2, '0')
    let yyyy = d.getFullYear()
    return `${dd}.${mm}.${yyyy}`
}

if (document.getElementById('personal_account_pay_modal')) {
// Модалка для оплаты
    (() => {
        const modal = document.getElementById('personal_account_pay_modal');
        const span = modal.querySelector(".closepas");
        const btn = document.getElementById('personal_account_show_pay_form')
        const form = modal.querySelector('form')

        btn.onclick = function () {
            modal.style.display = "block";
        }

        span.onclick = function () {
            modal.style.display = "none";
        }

        window.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        });
        
        form.onsubmit = function() {
            const inp = document.getElementById('pa_pay_sum');
            if (inp.value.length === 0) {
                toastr.error('Введите сумму');
                return false;
            }
            if (parseFloat(inp.value) < parseFloat(inp.dataset.min)) {
                toastr.error(`Минимальная сумма для пополнения ${inp.dataset.min} рублей`);
                return false;
            }
            return true;
        }
        
    })();

    window.history.pushState(null, null, window.location.href.split('?')[0]);
}
